import classNames from 'classnames';
import { UDText } from 'ud-ui/components';

interface IProps {
  header: string;
  children?: React.ReactNode;
  className?: string;
}

function ListView(props: IProps) {
  const { header, children, className } = props;

  return (
    <div className={classNames(className, 'flex flex-col overflow-hidden rounded-2xl')}>
      <div className={'bg-DarkBlue p-2'}>
        <UDText isNew type={'title-1'} className={'text-white'}>
          {header}
        </UDText>
      </div>
      {children}
    </div>
  );
}

export default ListView;
